(function () {
	'use strict';

	angular
		.module('wizard-english-test')
		.controller('HomepageController', HomepageController);

	/** @ngInject */
	function HomepageController($location, $window) {
		const vm = this;

		// Função para capturar UTM params e salvar no sessionStorage
		function initUTM() {
			const allowedParams = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "fbclid"];
			const queryParams = $location.search(); // pega todos os query params
			let filteredParams = {};

			// Filtra apenas os utms permitidos
			Object.keys(queryParams).forEach(param => {
				if (allowedParams.includes(param)) {
					filteredParams[param] = removeSpecialChar(queryParams[param]);
				}
			});

			// Se não tiver nenhum UTM válido
			if (Object.keys(filteredParams).length === 0) {
				sessionStorage.setItem("urlQueries", "no_utm_source");
				return;
			}

			// Transforma em string: utm_source=google&utm_medium=cpc...
			const queryString = Object.entries(filteredParams)
				.map(([key, value]) => `${key}=${value}`)
				.join('&');

			sessionStorage.setItem("urlQueries", queryString);
		}

		// Função para identificar origem e salvar qsMidia
		function initOrigin() {
			const search = $location.search();
			const mediaUrl = search.mID || null;

			let qsMidia = "46"; // default

			if (mediaUrl) {
				qsMidia = mediaUrl;
			} else {
				const referrer = $window.document.referrer;
				if (referrer) {
					const domain = new URL(referrer).hostname.split('.')[1];
					if (domain === 'google') {
						qsMidia = "16";
					} else if (domain === 'facebook') {
						qsMidia = "15";
					} else if (['twitter', 't.co'].includes(domain)) {
						qsMidia = "16";
					} else {
						qsMidia = "57";
					}
				}
			}

			sessionStorage.setItem("qsMidia", qsMidia);
		}

		// Função auxiliar para remover caracteres especiais
		function removeSpecialChar(str) {
			return str.replace(/['"\\,;<> ]/g, '');
		}

		// Executar as funções ao carregar o controller
		vm.$onInit = function () {
			initUTM();
			initOrigin();
		};
	}
}());